import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const RawMaterialMaster = React.lazy(() => import('.'));

export const rawMaterialMasterRoutes = [
  new Route({
    path: 'raw-material-master',
    element: RawMaterialMaster,
    children: [],
  }),
];
